import React, { Component } from 'react';
import get from 'lodash/get';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import api from 'src/api';
import Thumbnail from 'src/components/common/thumbnail';
import withModel from 'src/components/common/with-model';
import PublicShareContainer from 'src/components/packet-share/public-share-container';
import emptyCoverSheet from 'src/images/documents/cover_sheet_placeholder.png';
import logger from 'src/logger';
import getLocalStorage from 'src/utils/local-storage';
import ContactCard from './components/contact-card';
import SectionRequested from './components/section-requested';
import SectionWelcome from './components/section-welcome';



const clsPrefix = 'public-request-access';

@withModel
@inject('router', 'requestPacketAccess', 'ui', 'features')
@observer
export default class RequestPacketAccessContainer extends Component {
  static propTypes = {
    model: PropTypes.object,
    requestPacketAccess: PropTypes.object,
    ui: PropTypes.object,
    router: PropTypes.object,
    features: PropTypes.object,
  };
  state = {
    didCompleteRequest: false,
    requesting: false,
  };

  static model = async (publicStore, route) => {
    const { token } = route.params;
    await publicStore.requestPacketAccess.getPacketData(token);
    const ret = publicStore.requestPacketAccess.packets[token];
    let sharedItemUuid;
    try {
      getLocalStorage()
        .defaultsDeep({
          sharedItemAccessMap: {},
        })
        .write();
      sharedItemUuid = getLocalStorage()
        .get('sharedItemAccessMap')
        .get(ret.uuid)
        .value();
    } catch (err) {
      logger.error(err);
      sharedItemUuid = null;
    }

    if (sharedItemUuid) {
      publicStore.router.navigate(
        'sharedItem',
        {
          uuid: sharedItemUuid,
        },
        {
          replace: true,
        }
      );
    }
    if (ret.quickApproveAccess) {
      const result = await publicStore.requestPacketAccess.saveAccessRequest(
        ret.uuid
      );
      const uuid = result.data.sharedItemUuid;
      if (uuid) {
        publicStore.router.navigate('sharedItem', {
          uuid,
        });
      }
    }
    return ret;
  };

  onSave = async (values) => {
    const { model, requestPacketAccess, ui, router } = this.props;
    const { name } = values;
    const [firstName, ...lastNames] = name.trim().split(' ');
    const lastName = lastNames.join(' ');
    this.setState({
      requesting: true,
    });
    try {
      const result = await requestPacketAccess.saveAccessRequest(model.uuid, {
        applicantEmail: values.email,
        applicantType: values.type,
        applicantPhone: values.phone,
        applicantFirstName: firstName,
        applicantLastName: lastName,
      });
      const { sharedItemUuid } = result.data;
      if (sharedItemUuid) {
        router.navigate('sharedItem', {
          uuid: sharedItemUuid,
        });
      } else {
        this.setState({
          didCompleteRequest: true,
        });
      }
    } catch (err) {
      ui.wentWrong(err);
    }
    this.setState({
      requesting: false,
    });
  };

  resetCompleteRequest = () => {
    this.setState({
      didCompleteRequest: false,
    });
  };

  render() {
    const { model, features } = this.props;
    const heroContent = get(model, 'heroContent', '');
    const { requesting } = this.state;
    const { address } = get(model, 'propertyDetails');
    return model ? (
      <PublicShareContainer
        className={clsPrefix}
        address={address}
        theme={model.theme}
        heroContent={heroContent}
        isCompass={model.isCompass}
      >
        <div className={`${clsPrefix}__box`}>
          <div className={`${clsPrefix}__form-wrap`}>
            {this.state.didCompleteRequest ? (
              <SectionRequested onRequestAgain={this.resetCompleteRequest} />
            ) : (
              <SectionWelcome
                handleSubmit={this.onSave}
                submitting={requesting}
              />
            )}
          </div>
          <div className={`${clsPrefix}__side flex-cols`}>
            {model.coverSheetUrl ? (
              <Thumbnail
                className={`${clsPrefix}__side-inset`}
                url={model.coverSheetUrl}
                fetchThumbnail={
                  features?.docsUseProxyThumbnail
                    ? () => api.sharedPacket.getCoversheetThumbnail(model.uuid)
                    : undefined
                }
                defaultImage={emptyCoverSheet}
              />
            ) : (
              <img
                className={`${clsPrefix}__side-inset`}
                src={emptyCoverSheet}
                alt=""
              />
            )}
            <div className={`${clsPrefix}__side-info flex-rows justify-center`}>
              {!!model.firstAgent && (
                <ContactCard agent={model.firstAgent} label="Listing Agent" />
              )}
              {!!model.secondAgent && (
                <ContactCard agent={model.secondAgent} label="Listing Agent" />
              )}
            </div>
          </div>
        </div>
      </PublicShareContainer>
    ) : null;
  }
}
